var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3289 17.4945V15.8284C13.3289 14.9446 12.9779 14.097 12.353 13.4721C11.728 12.8472 10.8805 12.4961 9.99668 12.4961H4.99828C4.11451 12.4961 3.26694 12.8472 2.64201 13.4721C2.01709 14.097 1.66602 14.9446 1.66602 15.8284V17.4945",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49755 9.1638C9.33791 9.1638 10.8298 7.67189 10.8298 5.83153C10.8298 3.99117 9.33791 2.49927 7.49755 2.49927C5.65719 2.49927 4.16528 3.99117 4.16528 5.83153C4.16528 7.67189 5.65719 9.1638 7.49755 9.1638Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3276 17.4943V15.8282C18.327 15.0899 18.0813 14.3727 17.6289 13.7891C17.1766 13.2056 16.5432 12.7888 15.8284 12.6042",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3291 2.60742C14.0459 2.79095 14.6812 3.20781 15.1349 3.7923C15.5886 4.37679 15.8348 5.09565 15.8348 5.83556C15.8348 6.57546 15.5886 7.29432 15.1349 7.87881C14.6812 8.4633 14.0459 8.88016 13.3291 9.06369",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9936,
    height: 19.9936,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon05.7992405c5ca63ad5fe544fde7bbbd794.svg";
export { ForwardRef as ReactComponent };